<template>
    <div class="digital">
        <p class="digital_title" v-if="isShow">Be a BDO Merchant Partner now and provide better payment options for your customers</p>
        <p class="digital_title" v-if="!isShow">Be a BDO Merchant Partner now and provide better payment options for your customers</p>
        <template v-if="isShow">
            <p class="digital_store_title blod" v-if="isShow">Digital Store</p>
            <div class="store_box">
                <div class="box" :class="posStyle" v-for="(item,index) in this.storeAppList" :key="index">
                    <img :src="item.img" />
                    <h2>{{item.title}}</h2>
                    <p>{{item.content}}</p>
                </div>
            </div>
        </template>
        <template v-else>
            <p class="digital_pos_title blod">Physical Store</p>
            <!-- <p class="digital_store_title pos_title" v-if="!isShow">Point-of-Sale Terminals</p> -->
            <div class="store_box">
                <div class="box posBox" v-for="(item,index) in this.storePosList1" :key="index">
                    <img :src="item.img" />
                    <h2>{{item.title}}</h2>
                    <p>{{item.content}}</p>
                </div>
            </div>
            <!-- <p class="digital_store_title pos_title" v-if="!isShow">miniPOS</p> -->
            <div class="store_box">
                <div class="box posBox" v-for="(item,index) in this.storePosList2" :key="index">
                    <img :src="item.img" />
                    <h2>{{item.title}}</h2>
                    <p>{{item.content}}</p>
                    <p style="margin-top: 14px;font-style: oblique;">{{item.content2}}</p>
                </div>
            </div>
        </template>
        <p class="digital_store_title bottom_title" v-if="isShow">Which BDO Payment solutions are you applying for?</p>
        <p class="digital_store_title bottom_title" v-if="!isShow">Which BDO Payment solutions are you applying for?</p>
        <p class="digital_title">You may choose 1 or more products from the digital/physical store options.</p>
        <div class="check_box">
            <BdoCheckbox :checkboxList="boxData" @checkboxClick="checkboxClick" />
        </div>
    </div>
</template>

<script>
import BdoCheckbox from "../../components/BdoCheckbox.vue"
export default {
    name: "Digital",
    props: {
        // app为Digital Store  pos为Physical Store
        digitalType: {
            type: String,
            default: "app"
        },
        digitalData: {
            type: Array,
            default: () => []
        }
    },
    components: {
        BdoCheckbox
    },
    data() {
        return {
            storeAppList:[
                {
                    img: require("@/assets/pc/Image1@2x.png"),
                    title:"Payment Links",
                    content:"Accept credit card, debit card, and mobile wallet payments using a link you can send to customers via chat."
                },
                {
                    img: require("@/assets/pc/Image2@2x.png"),
                    title:"Email Billing",
                    content:"Create and send a digital billing to your customer wherever they are."
                },
                {
                    img: require("@/assets/pc/Image3@2x.jpg"),
                    title:"Website Plug-in",
                    content:"Integrate credit card, debit card, and mobile wallet payment options directly on your website."
                },
                {
                    img: require("@/assets/pc/Image4@2x.png"),
                    title:"Checkout App",
                    content:"Onboard easily as a Merchant Partner, and use the app to accept QR payments in-store."
                },
            ],
            storePosList1: [
                {
                    img: require("@/assets/pc/Image5@2x.jpg"),
                    title:"In-store POS",
                    content:"Accept card and mobile wallet payments using a POS terminal powered by SIM, WiFI or LAN connection. Ideal for merchants that may require cash register integration or over-the-counter transactions. "
                },
                {
                    img: require("@/assets/pc/Image6@2x.jpg"),
                    title:"Mobile POS",
                    content:"Accept card and mobile wallet payments using a handy and wireless POS terminal powered by SIM or WiFi. Ideal for merchants that require ‘pay at table’, deliveries, events and other mobile transactions. "
                },
            ],
            storePosList2: [
                {
                    img: require("@/assets/pc/Image7@2x.jpg"),
                    title:"miniPOS",
                    content:"Accept cashless payments with a wireless and easy to set-up device. Enjoy these benefits and more for only P13,990* with no minimum sales required. Ideal for start-ups and small to medium enterprises.",
                    content2:"*Price is subject to change without notice.",
                },
            ],
            appBoxList: [
                { productName: "Payment Links", chooseFlag: "1", customFlag: "1" },
                { productName: "Email Billing", chooseFlag: "1", customFlag: "1" },
                { productName: "Website Plug-in", chooseFlag: "1", customFlag: "1" },
                { productName: "Checkout App", chooseFlag: "1", customFlag: "1" },
            ],
            posBoxList: [
                { productName: "In-store POS", chooseFlag: "1", customFlag: "1" },
                { productName: "Mobile POS", chooseFlag: "1", customFlag: "1" },
                { productName: "miniPOS", chooseFlag: "1", customFlag: "1" },
            ]
        }
    },
    computed: {
        storeData() {
            if (this.digitalType === "app") {
                return this.storeAppList
            } else {
                return this.storePosList
            }
        },
        boxData() {
            if (this.digitalType === "app") {
                return this.appBoxList
            } else {
                return this.posBoxList
            }
        },
        posStyle() {
            return this.digitalType === "app" ? "" : "posBox"
        },
        isShow() {
            return this.digitalType === "app"
        }
    },
    watch: {
        digitalData:function(val) {
            if(val && val.length !== 0) {
                if (this.digitalType == "app") {
                    this.appBoxList = val
                } else {
                    this.posBoxList = val
                }
            }
        },
    },
    methods: {
        checkboxClick(val) {
            this.$emit("checkboxClick", val)
        }
    }
}
</script>

<style lang="scss" scoped>
.digital{
    .digital_store_title {
        margin: 24px 0 16px;
        font: normal normal normal 16px/22px Nunito-bold;
        color: #004EA8;
    }
    .blod {
        color: #2E2E2E;
        font: normal normal normal 20px/24px Nunito-bold;
    }
    .pos_title {
        margin: 8px 0 16px;
    }
    .digital_pos_title {
        color: #2E2E2E;
        font: normal normal normal 20px/27px Nunito-bold;
        margin: 16px 0 8px;
    }
    .bottom_title {
        margin-top: 8px;
    }
    .store_box {
        &::after {
            content:'';
            display: block;
            height: 0;
            clear: both;
            visibility: hidden;
        }
        .box {
            float: left;
            width: 418px;
            min-height: 330px;
            background: #FFFFFF 0% 0% no-repeat padding-box;
            box-shadow: 0px 0px 16px #00000029;
            border-radius: 16px;
            color: #2E2E2E;
            margin-right: 22px;
            margin-bottom: 24px;
            padding-bottom: 14px;
            &:nth-child(2n) {
                margin-right: 0;
            }
            img {
                width: 100%;
                vertical-align: top;
                border-top-left-radius: 16px;
                border-top-right-radius: 16px;
            }
            h2 {
                font: normal normal normal 16px/22px Nunito-bold;
                margin: 24px 14px 4px;
            }
            p {
                font: normal normal normal 14px/20px Nunito;
                margin: 0 14px;
            }
        }
        .posBox {
            h2 {
                font: normal normal normal 16px/22px Nunito-bold;
                margin: 8px 14px 4px;
            }
            p {
                font: normal normal normal 14px/20px Nunito;
                margin: 0 14px;
            }
        }
    }
    .check_box {
        margin-top: 24px;
    }
}
</style>